import React, { FC } from 'react';

import { NotificationsTable } from './components';
import { Wrapper } from './styles';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const Notifications: FC = () => {
  const { isExpiredSoon, isBlocked } = useSubscription();

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <NotificationsTable />
    </Wrapper>
  );
};

export default Notifications;
